import { ui } from '@owenscorning/pcb.alpha';

import Content from './Content';
import QrRedirectPreview from '../../../PageBuilder/campaign/qr_redirect_preview';

const QrRedirect = Content('QrRedirect', () => ({
  version: '0.1',
  displayName: 'QR Redirect',
  paths: ['c'],
  view: {},
  sidebar: {
    builder: ui`Form`.of({}),
  },
}));

QrRedirect.Renderer = () => ({
  contents: QrRedirectPreview,
});

export default QrRedirect;
